import { IKonfigurationStPos } from "../../Models/IKonfigurationStPos";

export const getGesamtwirkungsgrad = (positionen: IKonfigurationStPos[]) => {
  if (positionen != undefined && positionen?.length > 0) {
    let wirkungsgrad = 1;

    for (let i = 0; i < positionen.length; i++) {
      let ratio = positionen[i]?.artikel?.sachwerte?.filter(
        (x: any) => x.nameEN == "Efficiency factor"
      )[0];
      const wert = ratio && ratio.wert ? Number(ratio.wert) : 0;
      wirkungsgrad *= wert > 0 ? wert : 1;
    }

    return wirkungsgrad;
  } else {
    return 0;
  }
};
